var QueryString = function () {
    // This function is anonymous, is executed immediately and
    // the return value is assigned to QueryString!
    var query_string = {};
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        // If first entry with this name
        if (typeof query_string[pair[0]] === "undefined") {
            query_string[pair[0]] = decodeURIComponent(pair[1]);
            // If second entry with this name
        } else if (typeof query_string[pair[0]] === "string") {
            var arr = [query_string[pair[0]], decodeURIComponent(pair[1])];
            query_string[pair[0]] = arr;
            // If third or later entry with this name
        } else {
            query_string[pair[0]].push(decodeURIComponent(pair[1]));
        }
    }
    return query_string;
}();

function getCookies() {
    var pairs = document.cookie.split(";");
    var cookies = {};
    for (var i = 0; i < pairs.length; i++) {
        var pair = pairs[i].split("=");
        cookies[String(pair[0]).trim()] = unescape(pair[1]);
    }
    return cookies;
}

function openRegisterModal() {
    $(function () {
        $('#open-login-modal').trigger('click');
        $('#register-tab-button').trigger('click');
    });
}

function openLoginModal() {
    $(function () {
        $('#open-login-modal').trigger('click');
    });
}

//refresh csrf token after each vue http request
Vue.http.interceptors.push(function (request, next) {

    // modify request
    var xsrf = getCookies()["XSRF-TOKEN"];
    if (xsrf) {
        request.headers.set('X-XSRF-TOKEN', getCookies()["XSRF-TOKEN"]);
    }
    else {
        request.headers.set('X-CSRF-TOKEN', token);
    }

    next(function (response) {
        // modify response
        var token = response.headers.get('_token');

        if (token) {
            //set new token to each hidden form input
            _.each($('input[name="_token"]'), function (value) {
                $(value).val(token);
            });

            //set global token variable to new token
            window.token = token;

            //set meta token value to new token
            $('meta[name="csrf-token"]').attr('content', token);
        }
    });

});

var timeoutForSearch;
var searchRequest;
$(function () {
    $('div.content').hide();
    $('#submitSub').click(function (e) {

        e.preventDefault();

        Swal({
            title: 'Privola za slanje e-pošte s aktualnostima (e-letka)',
            text: 'DA, želim primati redovitu e-poštu s aktualnostima (e-letak) i dajem dopuštenje da Hrvatska gospodarska komora koristi moje osobne podatke u svrhu slanja redovite e-pošte s aktualnostima.',
            input: 'checkbox',
            inputValue: 0,
            showCancelButton: true,
            cancelButtonText: 'Odustani',
            inputPlaceholder: '',
            confirmButtonText: 'Nastavak',
            inputValidator: function (result) {
                return !result && 'Trebate prihvatiti uvjete!'
            }
        }).then(function (result) {

            if (result) {
                $.ajax({
                    url: '/subscriber',
                    method: "POST",
                    data: {
                        email: $('div.input-cell input#subscription_email').val(),
                        _token: $('input[name=_token]').val(),
                        lang: lang.current,
                        _method: 'PUT'
                    },
                    success: function (data) {
                        if (data == '1') {
                            $('div.content').hide().removeClass('success error').addClass('success').html(lang.subscribeSuccess).fadeIn('fast');
                        } else if (data == '2') {
                            $('div.content').hide().removeClass('success error').addClass('success').html(lang.againSuccess).fadeIn('fast');
                        } else {
                            $('div.content').hide().removeClass('success error').addClass('error').html(data).fadeIn('fast');
                        }
                    }
                });
            }
        })

    });

    $("#search-box").keyup(function () {
        clearTimeout(timeoutForSearch);
        timeoutForSearch = setTimeout(doSearch, 800);
    });

    if ($("#phys_address_map").length) {

        var location = {lat: "45.8084126", lng: "15.968573900000024"}

        if (typeof section_location !== 'undefined') {
            location = {lat: section_location.lat, lng: section_location.lng}
        }

        var latlng = new google.maps.LatLng(location.lat, location.lng);
        var myOptions =
            {
                zoom: 15,
                center: latlng,
                mapTypeId: google.maps.MapTypeId.ROADMAP
            };
        var map = new google.maps.Map(document.getElementById("phys_address_map"), myOptions);
        var myMarker = new google.maps.Marker(
            {
                position: latlng,
                map: map,
                title: "Pune"
            });

    }

    $('#biznetAjax').click(function (e) {
        e.preventDefault();
        $.ajax({
            type: "POST",
            url: ajax_url + '/biznetSearch',
            data: {'oib': $("#biznetOIB").val(), _token: $('input[name=_token]').val()},
            success: function (data) {
                if (data.success) {
                    $("#biznetAjaxReturn").hide();
                    $("#biz-data").html(data.render);
                } else {
                    $("#biznetAjaxReturn").show();
                    $("#biznetAjaxReturn").html(data.message);
                }
            }
        });
    });
    $("#biznetOIB").keyup(function () {
        if ($(this).val().length == 11) $('#biznetAjax').attr('disabled', false);
        else $('#biznetAjax').attr('disabled', true);
    });

});

function doSearch(search) {
    $("#suggesstion-box").hide();
    $('.search-loader').show();

    if (searchRequest)
        searchRequest.abort();

    searchRequest = $.ajax({
        type: "POST",
        url: ajax_url + '/search',
        data: {'searchTerm': $("#search-box").val(), _token: $('input[name=_token]').val(), current: lang.current},
        success: function (data) {
            $("#suggesstion-box").show();
            $("#suggesstion-box").html(data);
            $("#search-box").css("background", "#FFF");
            $('.search-loader').hide();

        }
    });
}

/* GOOGLE ANALYTICS */
(function (i, s, o, g, r, a, m) {
    i['GoogleAnalyticsObject'] = r;
    i[r] = i[r] || function () {
        (i[r].q = i[r].q || []).push(arguments)
    }, i[r].l = 1 * new Date();
    a = s.createElement(o), m = s.getElementsByTagName(o)[0];
    a.async = 1;
    a.src = g;
    m.parentNode.insertBefore(a, m)
})(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');
ga('create', 'UA-54448022-1', 'auto');
ga('send', 'pageview');